import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import ReactQueryInfiniteTable from '../../../../../components/ReactQueryInfiniteTable';
import LoadingSpinner from '../../../../../components/Spinner';
import { setCurrentRecordId } from '../../../../../redux/modules/insuredProfilePage';
import { useInsuredActiveRecordsData } from '../../../../../services/insured-service';

import { COLUMNS } from './columns';

const RecordsBody = ({ insuredId, recordId }) => {
  const dispatch = useDispatch();
  const activeRecords = useInsuredActiveRecordsData({ insuredId });

  const columns = useMemo(() => COLUMNS, []);

  const handleRowClick = (e, rowId) => {
    if (rowId !== recordId && ((e.target.tagName === 'DIV') || (e.target.tagName === 'TD'))) {
      const pathWithoutRequirement = window.location.pathname.replace(/(\/records.*\/\d+)?$/, '');
      window.history.replaceState(null, '', `${pathWithoutRequirement}/records/${rowId}`);

      dispatch(setCurrentRecordId(rowId));
    }
  };

  if (activeRecords.isLoading) {
    return (
      <Box height="200px">
        <LoadingSpinner isInline minHeight="200px" />
      </Box>
    );
  }

  return (
    <ReactQueryInfiniteTable
      height="200px"
      reactQueryResponse={activeRecords}
      selectable={{
        selectedItemId: recordId,
        handleItemSelect: handleRowClick
      }}
      tableColumns={columns}
    />
  );
};

RecordsBody.propTypes = {
  insuredId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  recordId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default RecordsBody;
